import React from 'react';
import classNames from 'classnames';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';

import Citation from '@prospectus/modular-page/components/Citation';
import { formatRichText } from './formatting';

const addHeaderClassesToContentfulText = (classes, contentfulText) => {
  const options = {
    renderNode: {
      [BLOCKS.HEADING_2]: (node, children) => <h2 className={classNames(classes)}>{children}</h2>,
    },
  };

  return formatRichText(contentfulText, options);
};

const removeParagraphsFromContentfulText = (contentfulText) => {
  const options = {
    renderNode: {
      // Rich text comes wrapped in a p by default and we want to remove the p tags entirely
      [BLOCKS.PARAGRAPH]: (node, children) => children,
    },
  };

  return formatRichText(contentfulText, options);
};

const formatEmbeddedEntries = (references = [], footnoteMap = {}) => ({
  [INLINES.EMBEDDED_ENTRY]: (node) => {
    const entry = references.find(reference => reference.contentful_id === node.data.target.sys.id);
    // eslint-disable-next-line no-underscore-dangle
    if (entry?.__typename === 'ContentfulMicroText') {
      return <p className="small">{entry.microtext.body}</p>;
    }
    // eslint-disable-next-line no-underscore-dangle
    if (entry?.__typename === 'ContentfulFootnote') {
      return <Citation footnoteId={entry.contentful_id} footnoteMap={footnoteMap} />;
    }
    return '';
  },
});

export {
  addHeaderClassesToContentfulText,
  removeParagraphsFromContentfulText,
  formatEmbeddedEntries,
};
